// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import type { State } from 'store/State';

// selectors
import { getTheme } from 'store/reducers/ui/theme/selectors';

type Props = {|
  /** The theme name, it's a folder inside src/styles/themes */
  theme: string,
  /** A single child to render */
  children: React.Node
|};

// sets the classname `theme-${theme}` on the html element
class ThemeProvider extends React.Component<Props> {
  toggleDocumentElementThemeClass() {
    const { theme } = this.props;
    const html = document.documentElement;
    if (html) {
      Array.prototype.slice.call(html.classList).forEach(cls => {
        if (cls.indexOf('theme') === 0) {
          html.classList.remove(cls);
        }
      });
      html.classList.add(`theme-${theme}`);
    }
  }

  render() {
    this.toggleDocumentElementThemeClass();
    return React.Children.only(this.props.children);
  }
}

const mapStateToProps = (state: State) => ({ theme: getTheme(state) });

// empty object avoids injecting dispatch
// see https://github.com/reactjs/react-redux/blob/master/docs/api.md#arguments
export default connect(
  mapStateToProps,
  {}
)(ThemeProvider);



// WEBPACK FOOTER //
// ./src/components/common/providers/theme/ThemeProvider.js